const ease=x=>{x=Math.max(0,Math.min(1,x));return x*x*x*(x*(x*6-15)+10);};
function gesture(t,start,rise,hold,fall){
 if(t<start)return 0;
 if(t<start+rise)return ease((t-start)/rise);
 if(t<start+rise+hold)return 1;
 return 1-ease((t-start-rise-hold)/fall);
}

// One shared pose drives pixels, hover silhouettes and inverse-transform hit tests.
export function characterPose(ms,night=0){
 const t=ms/1000,phase=t%24;
 // The warming gesture occupies the idle part of the same loop, after the check returns.
 const warm=gesture(phase,14,2.8,3.5,3.2)*ease((night-.55)/.4);
 const look=Math.max(gesture(phase,4.8,1.87,4.33,2.21),warm*.82);
 const gaze=Math.max(gesture(phase,4.2,.6,6.2,2.04),warm);
 const blowStart=7.185;
 const blow=gesture(phase,blowStart,.45,1.8,.65);
 const headAngle=look*.075,headScaleX=1-look*.075;
 // Keep the head's original shoulder attachment fixed while turning the face.
 const anchorX=595-659,anchorY=500-505;
 return {
  look,warm,gaze,blow,puffPhase:Math.max(0,(phase-blowStart-.3)/1.6),
  headAngle,headScaleX,
  headX:anchorX-(anchorX*headScaleX*Math.cos(headAngle)-anchorY*Math.sin(headAngle)),
  headY:anchorY-(anchorX*headScaleX*Math.sin(headAngle)+anchorY*Math.cos(headAngle)),
  faceX:look*19,
  faceY:look*6,
  gazeX:gaze*3,
  gazeY:gaze*2.2,
  freeArmAngle:-warm*1.04,
  // Small settling motion only while the hand is extended.
  freeArmY:-warm*3+Math.sin(t*1.3)*warm*.7
 };
}
